module.exports = __webpack_public_path__ + "img/WALK-COMFORT-A-GAUCHE.99178d42.svg";